enum PagesPaths {
  PublicHome = '/',
  PrivateHome = '/inicio',
  Login = '/iniciar-sesion',
  SignUp = '/registro',
  ActivateUser = '/activar-usuario',
  ForgotPassword = '/olvide-contraseña',
  ResetPassword = '/restablecer-contraseña',
  Contact = '/contacto',
  CostSimulator = '/simulador-de-costos',
  EIR = '/eir',
  OnlinePaymentInstructions = '/instuctivo-pagos-online',
  EInvoice = '/e-factura',
  NotFound = '*',
  Settings = '/inicio/configuracion',
  Schedule = '/inicio/escalas',
  ContainerTap = '/inicio/contenedores/ficha-de-contenedor',
  ContainerList = '/inicio/container-list',
  SearchByBooking = '/inicio/busqueda-por-booking',
  UnloadingList = '/inicio/lista-de-descarga',
  SOLAS = '/inicio/solas',
  ContainerRelease = '/inicio/contenedores/liberacion-de-importacion',
  Exchanges = '/parte-de-intercambios',
  NumberStock = '/numero-de-stock',
  AssignList = '/inicio/lista-de-asignaciones',
  DeliveryOrder = '/delivery-order',
  StockContainers = '/inicio/contenedores-de-exportacion',
  StockSummary = '/inicio/resumen-de-stock',
  // PronosticoCarga = '/inicio/pronostico-de-carga',
  DetailedStock = '/inicio/detalle-de-stock',
  CustomerRegistration = '/inicio/alta-del-cliente',
  OrdenDeTrabajo = '/inicio/generar-orden-de-trabajo',
  paymentInquiry = '/inicio/consulta-de-gastos',
  documentsWeb = '/inicio/documentos-web',
  documentsHistory = '/inicio/documentos-historico',
  mySettlement = '/inicio/mi-liquidacion',
  Depo20 = '/inicio/mi-liquidacion/depo20',
  ImportFCL = '/inicio/mi-liquidacion/importacion-fcl',
  VacioImportacion = '/inicio/mi-liquidacion/vacio-importacion',
  ServicioAdicional = '/inicio/mi-liquidacion/servicio-adicional',
  ExportFCL = '/inicio/mi-liquidacion/exportacion-fcl',
  ScheduleDetail = '/inicio/detalle-de-agenda',
  paymentPendings = '/inicio/pagos-pendientes',
  accountStatement = '/inicio/estado-de-cuenta',
}

export default PagesPaths;
